import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Container } from 'reactstrap';
// import logo from '../../images/logo-full.png';

import { Layout, PageTitle, FormGroup, Input, PillButton, PreLoader } from '../../components';
import useAuthenticateCustomer from '../../providers/Customer/useAuthenticateCustomer';
import { routes } from '../../constants';

function Login() {
  const {
    form: { email, password },
    _v,
    loading,
    handleSubmit,
  } = useAuthenticateCustomer();
  return (
    <Layout>
      <PageTitle pageName="login-page" title="Login" />
      <div className="contact login-page-content pb-5 mb-5">
        <Container>
          <div className="row justify-content-center">
            <Col lg={6}>
              <div className="login-page-outer">
                <div className="login-form-outer">
                  <div className="section-title text-center">
                    {/* <img src={logo} alt="Browncon Investing" width="240" className="mb-5" /> */}

                    <h2>
                      {/* Sign Up To<span> Browncon Investing</span> */}
                      Login To <span>Your Account</span>
                    </h2>
                  </div>
                </div>
                <form className="contact-form" onSubmit={handleSubmit}>
                  <Row>
                    <Col xl={12} lg={12}>
                      <FormGroup>
                        <Input
                          id="email"
                          required
                          {...email(_v.email)}
                          placeholder="Enter Your E-mail Address"
                          label="E-mail"
                          // type="email"
                        />
                      </FormGroup>
                    </Col>
                    <Col xl={12} lg={12}>
                      <FormGroup>
                        <Input
                          id="password"
                          required
                          {...password(_v.password)}
                          placeholder="Enter Your Password"
                          label="Password"
                          // type="password"
                        />
                      </FormGroup>
                    </Col>
                    {/* <Col xl={12} lg={12}>
                    <FormGroup className="mb-0 checkbox">
                      <CheckBox id="gridCheck1" label="Keep me logged in" />
                    </FormGroup>
                  </Col> */}
                    <Col xl={12} lg={12}>
                      <Row className="d-flex">
                        <Col className="text-center" xl={6} lg={6}>
                          {loading ? (
                            <PreLoader />
                          ) : (
                            <PillButton className="login-button" label="Send Now" type="submit" />
                          )}
                        </Col>
                        <Col xl={6} lg={6} className="align-items-center">
                          <Link to={routes.login} className="forgetting-password">
                            Forgot Password?
                          </Link>
                          <Link to={routes.join} className="forgetting-password mt-2">
                            New Account? Sign Up
                          </Link>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </form>
              </div>
            </Col>
          </div>
        </Container>
      </div>
    </Layout>
  );
}

export default Login;
